<template>
  <div class="definitions-tab">
    <section class="header-section">
      <div
        class="d-flex align-center"
        style="gap: 10px;"
      >
        <span style="font-size: 14px; color: #E7E3FC;">N° SLT: <strong style="color:#FF821A;">{{ solicData.code || '-' }}</strong></span>
        <div class="badge-container">
          <div
            class="badge"
            :style="getBadgeColor(solicData.status)"
          >
            <span>{{ solicData.status || '-' }}</span>
          </div>
        </div>
      </div>
      <div
        class="d-flex align-center"
        style="gap: 11px;"
      >
        <v-icon>{{ icons.mdiInformationOutline }}</v-icon>
        <span style="font-size: 14px; color: #E7E3FC;">Solicitado por <strong style="color: #E7E3FC;">{{ (solicData.created_by && solicData.created_by.name) || '-' }}</strong> no dia {{ formatDate(solicData.created_at) }} - {{ formatTime(solicData.created_at) }}</span>
      </div>
      <div
        class="d-flex align-center"
        style="gap: 11px;"
      >
        <v-icon>{{ icons.mdiOfficeBuildingMarkerOutline }}</v-icon>
        <span style="font-size: 14px; color: #E7E3FC;">Loja: <strong style="color: #E7E3FC;">{{ (solicData.created_by && solicData.created_by.company && solicData.created_by.company.fantasy_name) || '-' }}</strong></span>
      </div>
      <div
        class="d-flex align-center"
        style="gap: 11px;"
      >
        <v-icon>{{ icons.mdiDoorClosed }}</v-icon>
        <span style="font-size: 14px; color: #E7E3FC;">Setor: <strong style="color: #E7E3FC;">{{ (solicData.created_by && solicData.created_by.occupation_sector && solicData.created_by.occupation_sector.sector && solicData.created_by.occupation_sector.sector.name) || '-' }}</strong></span>
      </div>
    </section>

    <div class="content-area">
      <div
        class="d-flex flex-column"
        style="gap: 16px;"
      >
        <span style="font-size: 15px; font-weight: 600; color: #E7E3FC;">Que tipo de viagem você deseja fazer?</span>
        <v-autocomplete
          v-model="type"
          :items="listTypesItem"
          label="Tipo de viagem"
          outlined
          dense
          :disabled="!isEditMode"
          @input="onFieldChange"
        />
      </div>
      <div
        v-if="type"
        class="d-flex flex-column"
        style="gap: 16px;"
      >
        <span style="font-size: 15px; font-weight: 600; color: #E7E3FC;">Qual a categoria da sua viagem?</span>
        <v-autocomplete
          v-model="category"
          :readonly="!type"
          :disabled="!isEditMode"
          :items="listCategory"
          label="Categoria"
          outlined
          dense
          @input="onFieldChange"
        />
      </div>
    </div>

    <div class="actions-area mt-4">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
import axiosIns from '@/plugins/axios'
import { mdiDoorClosed, mdiInformationOutline, mdiOfficeBuildingMarkerOutline } from '@mdi/js'
import { getBadgeColor } from '../../helpers/badgeHelpers'
import { formatDate, formatTime } from '../../helpers/formatHelpers'

export default {
  name: 'DefinitionsTab',
  props: {
    solicData: {
      type: Object,
      default: () => ({}),
    },
    usersList: {
      type: Array,
      default: () => [],
    },
    vehiclesList: {
      type: Array,
      default: () => [],
    },
    driversList: {
      type: Array,
      default: () => [],
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icons: {
        mdiInformationOutline,
        mdiOfficeBuildingMarkerOutline,
        mdiDoorClosed,
      },
      type: this.solicData.type || null,
      category: '',
      listTypesItem: ['Aqui mesmo na cidade', 'Fora da cidade'],
      listCategory: ['Deslocamento comum', 'Rota consórcio', 'Rota transporte'],
      isLoading: false,
      originalData: {},
      hasChanges: false,
    }
  },
  created() {
    this.category = this.solicData.category || null

    this.saveOriginalData()
  },
  methods: {
    formatDate,
    formatTime,
    getBadgeColor,

    saveOriginalData() {
      this.originalData = {
        type: this.solicData.type || null,
        category: this.solicData.category || null,
      }
    },

    enableEditMode() {
      // Método chamado pelo modal pai para habilitar edição
      console.log('Modo de edição habilitado no DefinitionsTab')
    },

    cancelEdit() {
      // Restaura dados originais
      this.type = this.originalData.type
      this.category = this.originalData.category
      this.hasChanges = false
    },

    onFieldChange() {
      this.hasChanges = this.checkForChanges()
      if (this.hasChanges) {
        this.$emit('data-changed')
      }
    },

    checkForChanges() {
      return (
        this.type !== this.originalData.type
        || this.category !== this.originalData.category
      )
    },

    validateForm() {
      return true
    },
    getData() {
      return {
        type: this.type,
        category: this.category,
      }
    },

    async saveDefinitions() {
      try {
        this.isLoading = true
        const data = this.getData()
        const body = { ...data }

        await axiosIns.put(`/api/v1/solicitations/transport_solicitation_trip/update/${this.solicData.id}`, body)

        this.$swal({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Definições atualizadas com sucesso!',
          showConfirmButton: false,
          timer: 3000,
        })

        // Atualiza dados originais após salvar
        this.saveOriginalData()
        this.hasChanges = false

        return true
      } catch (error) {
        console.error('Error updating definitions:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro!',
          text: 'Erro ao atualizar definições.',
        })

        return false
      } finally {
        this.isLoading = false
      }
    },

  },
}
</script>

<style scoped>
.definitions-tab {
  width: 100%;
}

.content-area {
  margin-top: 48px;
  display: flex;
  flex-direction: column;
}

.actions-area {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.header-section {
  display: flex;
  flex-direction: column;
  gap: 13px;
}
.badge {
  padding: 3px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  font-weight: 600;
  text-align: center;
  font-size: 11px;
}
.badge-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
